/**
 * デバイス判定
 *
 * @param {String} device - 'pc' または 'sp'
 * @return {boolean}
 */
export const mq = (device) => {
  const isSP = window.matchMedia("(max-width: 768.9px)").matches;
  const isPC = window.matchMedia("(min-width: 769px)").matches;

  if (device === "sp") {
    return isSP;
  }
  if (device === "pc") {
    return isPC;
  }
  return false; // 不明な引数が渡された場合
};

/**
 * ページトップへスクロール - Vanilla JavaScript
 *
 * @param {string} val
 */
export const goToPageTop = (val) => {
  const elements = document.querySelectorAll(val);
  elements.forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
};

/**
 * スムーススクロール - Vanilla JavaScript
 *
 * @param {string} val
 */
export const smoothScroll = (val) => {
  const elements = document.querySelectorAll(val);
  elements.forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();

      const href = element.getAttribute("href");
      const targetSelector = href === "#" || href === "" ? "html" : href;
      const target = targetSelector === "html" ? document.documentElement : document.querySelector(targetSelector);

      if (target) {
        const position = target.offsetTop; // ターゲット要素のトップ位置を取得
        window.scrollTo({
          top: position,
          behavior: "smooth", // スムーズスクロールを有効化
        });
      }
    });
  });
};

/**
 * アコーディオン処理 - Vanilla JavaScript
 *
 * @param {string} val
 */
export const showAccordion = (val) => {
  const elements = document.querySelectorAll(val);

  // 初期状態で次の要素を非表示にする
  elements.forEach((element) => {
    const nextSibling = element.nextElementSibling;
    if (nextSibling) {
      nextSibling.style.display = "none";
    }

    // クリックイベントをバインド
    element.addEventListener("click", () => {
      const isOpen = element.classList.contains("show-accordion");
      if (isOpen) {
        element.classList.remove("show-accordion");
        if (nextSibling) {
          nextSibling.style.display = "none"; // アコーディオンを閉じる
        }
      } else {
        element.classList.add("show-accordion");
        if (nextSibling) {
          nextSibling.style.display = "block"; // アコーディオンを開く
        }
      }
    });
  });
};

/**
 * アコーディオン処理2 - Vanilla JavaScript
 *
 * @param {string} val
 */
export const showAllAccordion = (val) => {
  const headers = document.querySelectorAll(`${val} dt`);

  headers.forEach((header) => {
    header.addEventListener("click", (event) => {
      const tag = event.currentTarget;
      const dl = tag.closest("dl");
      const dds = dl.querySelectorAll("dd");

      if (tag.classList.contains("show")) {
        // すでに開いている場合
        tag.classList.remove("show");
        dds.forEach((dd) => (dd.style.display = "none")); // アコーディオンを閉じる
      } else {
        // 常に一つだけ開ける場合
        headers.forEach((h) => h.classList.remove("show")); // 他の開いているものを閉じる
        const allDds = document.querySelectorAll(`${val} dd`);
        allDds.forEach((dd) => (dd.style.display = "none")); // 他の開いているddを閉じる

        // 現在の要素を開く
        tag.classList.add("show");
        const nextDd = tag.nextElementSibling;
        if (nextDd && nextDd.tagName === "DD") {
          nextDd.style.display = "block";
        }
      }
    });
  });
};

/**
 * タブUI - Vanilla JavaScript
 *
 * @param {string} tabs
 * @param {string} tabContent
 */
export const showTab = (tabs, tabContent) => {
  const tab = document.querySelectorAll(`${tabs} > *`);
  const tabChild = document.querySelectorAll(`${tabContent} > *`);
  const url = window.location.href;
  const hash = url.split("#")[1]; // ハッシュ部分を取得

  // 初期表示
  if (hash) {
    const indexId = Array.from(tab).findIndex((t) => t.classList.contains(hash));
    if (indexId !== -1) {
      tab[indexId].classList.add("show-tab");
      tabChild.forEach((child, i) => {
        if (i === indexId) {
          child.style.display = "block";
          child.classList.add("show-tab-child");
        } else {
          child.style.display = "none";
          child.classList.remove("show-tab-child");
        }
      });
    }
  } else {
    tab[0].classList.add("show-tab");
    tabChild.forEach((child, i) => {
      if (i === 0) {
        child.style.display = "block";
        child.classList.add("show-tab-child");
      } else {
        child.style.display = "none";
        child.classList.remove("show-tab-child");
      }
    });
  }

  // タブクリックイベント
  tab.forEach((t, index) => {
    t.addEventListener("click", () => {
      tab.forEach((item) => item.classList.remove("show-tab"));
      t.classList.add("show-tab");

      tabChild.forEach((child, i) => {
        if (i === index) {
          child.style.display = "block";
          child.classList.add("show-tab-child");
        } else {
          child.style.display = "none";
          child.classList.remove("show-tab-child");
        }
      });
    });
  });
};

// CSSクラスを使用してトランジションを管理
const TRANSITION_PROPERTIES = 'height, margin, padding';
const TRANSITION_DURATION = '300ms';
const TRANSITION_TIMING_FUNCTION = 'ease';

const addTransition = (el) => {
  el.style.transitionProperty = TRANSITION_PROPERTIES;
  el.style.transitionDuration = TRANSITION_DURATION;
  el.style.transitionTimingFunction = TRANSITION_TIMING_FUNCTION;
  el.style.willChange = 'height, margin, padding'; // 最適化のヒント
};

const removeTransition = (el) => {
  el.style.transitionProperty = '';
  el.style.transitionDuration = '';
  el.style.transitionTimingFunction = '';
  el.style.willChange = '';
};

export const slideUp = (el, duration = 300) => {
  el.style.height = `${el.offsetHeight}px`;
  el.style.overflow = 'hidden';
  addTransition(el);

  requestAnimationFrame(() => {
    el.style.height = '0';
    el.style.paddingTop = '0';
    el.style.paddingBottom = '0';
    el.style.marginTop = '0';
    el.style.marginBottom = '0';
  });

  const handleTransitionEnd = () => {
    el.style.display = 'none';
    el.classList.remove('is-open');
    removeTransition(el);
    el.removeEventListener('transitionend', handleTransitionEnd);
  };

  el.addEventListener('transitionend', handleTransitionEnd);
};

export const slideDown = (el, duration = 300, flex = false) => {
  el.classList.add('is-open');
  el.style.removeProperty('display');

  let display = window.getComputedStyle(el).display;
  if (display === 'none') {
    display = flex ? 'flex' : 'block';
  }
  el.style.display = display;

  const height = el.scrollHeight; // offsetHeightよりscrollHeightの方が適切
  el.style.overflow = 'hidden';
  el.style.height = '0';
  el.style.paddingTop = '0';
  el.style.paddingBottom = '0';
  el.style.marginTop = '0';
  el.style.marginBottom = '0';
  addTransition(el);

  requestAnimationFrame(() => {
    el.style.height = `${height}px`;
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
  });

  const handleTransitionEnd = () => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    removeTransition(el);
    el.removeEventListener('transitionend', handleTransitionEnd);
  };

  el.addEventListener('transitionend', handleTransitionEnd);
};

export const slideToggle = (el, duration = 300, flex = false) => {
  if (window.getComputedStyle(el).display === 'none') {
    return slideDown(el, duration, flex);
  } else {
    return slideUp(el, duration);
  }
};


export const accordionsFunc = (elem) => {
  // console.log("accordionsFunc");

  if (!elem) return
    console.log(elem);
  // アコーディオンを全て取得
  const accordions = elem.querySelectorAll(".js-accordion");

  // 取得したアコーディオンをArrayに変換(IE対策)
  const accordionsArr = Array.prototype.slice.call(accordions);

  accordionsArr.forEach((accordion) => {
    // Triggerを全て取得
    const accordionTriggers = accordion.querySelectorAll(".accordion-title");

    // TriggerをArrayに変換(IE対策)
    const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);

    accordionTriggersArr.forEach((trigger) => {
      // Triggerにクリックイベントを付与
      const title = trigger.querySelector(".title");
      // const span = title.querySelector(".arrow");
      // const checkbox = title.querySelector(".input-checkbox");
      // const content = trigger.querySelector(".accordion-detail");
      // const input = content.querySelectorAll(".input-checkbox");
      let hasShow = false

      title.addEventListener("click", () => {
        console.log(hasShow);
        // '.show'クラスを付与or削除
        if (!hasShow) {
            trigger.classList.toggle("show");
        } else {
            hasShow = false;
         }
        // 開閉させる要素を取得

        const content = accordion.querySelector(".accordion-detail");
        // 要素を展開or閉じる
        slideToggle(content);
        // if (trigger.classList.contains("show")) {
        //   slideDown(content, 300, false);
        // } else {
        //   slideUp(content, 300);
        // }
      });

      if (trigger.classList.contains("show")) {
        hasShow = true
        title.click();
      }



      // if (checkbox === null) return;
      // checkbox.addEventListener("click", () => {
      //   const state = checkbox.checked;
      //   input.forEach((e) => {
      //     e.checked = state;
      //   });
      // });
    });
  });
};


/**
 * 月の数字を英語の3文字略称に変換する関数
 * @param {number} monthNumber - 1から12の整数
 * @returns {string} 英語の3文字略称（例："FEB"）
 * @throws {Error} 無効な月の数字が渡された場合
 */
export　const getMonthAbbreviation = (monthNumber) => {
  const monthAbbreviations = [
    "JAN", // 1
    "FEB", // 2
    "MAR", // 3
    "APR", // 4
    "MAY", // 5
    "JUN", // 6
    "JUL", // 7
    "AUG", // 8
    "SEP", // 9
    "OCT", // 10
    "NOV", // 11
    "DEC"  // 12
  ];

  if (
    typeof monthNumber !== "number" ||
    !Number.isInteger(monthNumber) ||
    monthNumber < 1 ||
    monthNumber > 12
  ) {
    throw new Error("有効な月の数字（1〜12）を入力してください。");
  }

  // 配列は0から始まるため、月番号から1を引く
  return monthAbbreviations[monthNumber - 1];
}
